<template>
    <div class="static-image" @click="$emit('click')">
        <transition name="fade" v-if="!isLoaded" >
            <div class="placeholder">
                <div class="spinner-border text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </transition>
        <transition name="fade" v-else>
            <api-img :comp="imageSrc" :alt="imageTitle" />
        </transition>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import apiImgPristine from '@@/shared/api-img-pristine.vue'
export default {
    components: {
		apiImg: apiImgPristine,
	},
    props: {
        hash: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters(['catalogStaticContent']),
        isLoaded(){
            return this.catalogStaticContent.length;
        },
        item() {
            return this.catalogStaticContent.find(item => item.hash === this.hash);
        },
        imageTitle() {
            return (this.item ? this.item.titulo : null);
        },
        imageSrc() {
            return (this.item ? this.item.imagenes_id : null);
        }
    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.6s ease;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

.fade-enter-to, .fade-leave {
    opacity: 1;
}
</style>